import { SelectionDropdown } from "../../../../../../../components/Dropdown/SelectionDropdown.tsx";
import type {
  ShadowDirection,
  ShadowDistance,
  ShadowStyle,
} from "../../../Designer/types.ts";
import { SETTINGS_ITEM_WIDTH } from "../../constants.ts";

type ShadowSettings = {
  shadowStyle: ShadowStyle;
  shadowDirection: ShadowDirection;
  shadowDistance: ShadowDistance;
};

const SHADOW_DIRECTIONS_DISPLAY_NAMES: Record<ShadowDirection, string> = {
  top: "Top",
  right: "Right",
  bottom: "Bottom",
  left: "Left",
};

const SHADOW_DISTANCES_DISPLAY_NAMES: Record<ShadowDistance, string> = {
  small: "Small",
  medium: "Medium",
  large: "Large",
};

const SHADOW_STYLES_DISPLAY_NAMES: Record<ShadowStyle, string> = {
  none: "None",
  soft: "Soft",
  medium: "Medium",
  strong: "Strong",
};

export const ShadowSettingsSection = ({
  shadowSettings,
  onShadowSettingsChange,
}: {
  shadowSettings: ShadowSettings;
  onShadowSettingsChange: (shadowSettings: Partial<ShadowSettings>) => void;
}) => (
  <div className="grid grid-cols-2 items-center gap-y-050 gap-x-200">
    <div className="label-md-default text-secondary">Strength</div>
    <ShadowStrengthDropdown
      strength={shadowSettings.shadowStyle}
      onStrengthChange={(shadowStyle) =>
        onShadowSettingsChange({ ...shadowSettings, shadowStyle })
      }
    />
    <div className="label-md-default text-secondary">Direction</div>
    <ShadowDirectionDropdown
      direction={shadowSettings.shadowDirection}
      onDirectionChange={(shadowDirection) =>
        onShadowSettingsChange({ ...shadowSettings, shadowDirection })
      }
    />
    <div className="label-md-default text-secondary">Distance</div>
    <ShadowDistanceDropdown
      distance={shadowSettings.shadowDistance}
      onDistanceChange={(shadowDistance) =>
        onShadowSettingsChange({ ...shadowSettings, shadowDistance })
      }
    />
  </div>
);

const ShadowDirectionDropdown = ({
  direction,
  onDirectionChange,
}: {
  direction: ShadowDirection;
  onDirectionChange: (direction: ShadowDirection) => void;
}) => (
  <SelectionDropdown
    value={direction}
    onChange={(shadowDirection) => onDirectionChange(shadowDirection)}
    options={Object.entries(SHADOW_DIRECTIONS_DISPLAY_NAMES).map(
      ([key, value]) => ({
        value: key as ShadowDirection,
        label: value,
      }),
    )}
    size="sm"
    buttonClassName={SETTINGS_ITEM_WIDTH}
  />
);

const ShadowDistanceDropdown = ({
  distance,
  onDistanceChange,
}: {
  distance: ShadowDistance;
  onDistanceChange: (distance: ShadowDistance) => void;
}) => (
  <SelectionDropdown
    value={distance}
    onChange={(shadowDistance) => onDistanceChange(shadowDistance)}
    options={Object.entries(SHADOW_DISTANCES_DISPLAY_NAMES).map(
      ([key, value]) => ({
        value: key as ShadowDistance,
        label: value,
      }),
    )}
    size="sm"
    buttonClassName={SETTINGS_ITEM_WIDTH}
  />
);

const ShadowStrengthDropdown = ({
  strength,
  onStrengthChange,
}: {
  strength: ShadowStyle;
  onStrengthChange: (strength: ShadowStyle) => void;
}) => (
  <SelectionDropdown
    value={strength}
    onChange={(shadowStyle) => onStrengthChange(shadowStyle)}
    options={Object.entries(SHADOW_STYLES_DISPLAY_NAMES).map(
      ([key, value]) => ({
        value: key as ShadowStyle,
        label: value,
      }),
    )}
    size="sm"
    buttonClassName={SETTINGS_ITEM_WIDTH}
  />
);
